import { boards } from "@/mocks/boards";
import { topics } from "@/mocks/topics";

export const getBoardById = (id: string) => boards.find((board) => board.id === id);

export const getTopicById = (id: string) => topics.find((topic) => topic.id === id);

export const getTopicsByBoard = (boardId: string) =>
  topics.filter((topic) => topic.board === boardId);

export const getHotTopics = (limit = 5) =>
  [...topics].sort((a, b) => b.views - a.views).slice(0, limit);

export const getBoardName = (boardId: string) => getBoardById(boardId)?.name ?? "综合讨论";